import { Chip } from '@mui/material';
import styled from 'styled-components';

import { COLORS } from 'theme';

export const DateChipWrapper = styled(Chip)`
  &.MuiChip-root {
    height: ${({ theme }) => theme.spacing.m3};
    color: ${COLORS.black80};
    border: 1px solid ${COLORS.black20};
    border-radius: ${({ theme }) => theme.borderRadius.secondary};
    cursor: inherit;
    font-size: ${({ theme }) => theme.fontSize.h5};
    background-color: ${COLORS.black06};
  }
  &&& .MuiChip-icon {
    margin-right: -${({ theme }) => theme.spacing.s2};
    margin-left: ${({ theme }) => theme.spacing.s1};
    font-size: 20px;
    path {
      fill: ${COLORS.black50};
    }
  }
  &&& .MuiChip-deleteIcon {
    width: ${({ theme }) => theme.spacing.s3};
  }
`;
